export class mobileVerification{
    mobileNumber:any;
    OTP:any
}